import styled, { css } from 'styled-components';
import { customMinResponsive, size, transitionMain, flex } from 'components/styles';

// Import components
import { Button } from 'components/elements/atoms/Button/Button';

export const StyledButton = styled(Button)`
	padding: 1rem;
`;

export const ChannelsList = styled.ul`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	grid-template-rows: repeat(2, 0.635fr);
	gap: 8px;
	width: 100%;
`;

export const ChannelsListItem = styled.li`
	${flex()}
	border-radius: 1.2rem;
	background: rgba(255, 255, 255, 0.04);
	padding: 15%;
`;

export const MoreChannelsButton = styled.button`
	background: transparent;
	width: 100%;
	height: 100%;
	border-radius: inherit;
	cursor: pointer;
	border: none;
	color: ${({ theme }) => theme.palette.white};
	font-size: 1.7rem;
	font-weight: ${({ theme }) => theme.font.bold};
	${transitionMain}

	&:hover {
		color: ${({ theme }) => theme.palette.primary.main};
	}

	${customMinResponsive(
		size.semi,
		css`
			font-size: 2rem;
		`
	)}
`;
